/**
 * Created by Mikhail Menshenin on 09.07.2024
 */

const Hut = function (village, data, id) {
    cleverapps.EventEmitter.call(this);
    this.village = village;
    this.id = id;
    this.level = 0;
    this.damage = 0;
    this.upgrades = [];
    this.repairs = [];
    this.upgradeable = false;
    this.upgradeTool = false;

    this.init(data);
};

Hut.prototype = Object.create(cleverapps.EventEmitter.prototype);
Hut.prototype.constructor = Hut;

Hut.prototype.init = function (data) {
    Object.assign(this, data);

    const hutsLevels = this.getMaxLevel() === 5 ? Hut.UPGRADE_COST_COEFFS_FIVE : Hut.UPGRADE_COST_COEFFS_FOUR;
    this.upgrades = hutsLevels[this.id].map((cost) => ({
        hard: Math.round((cost / 100) * this.village.cost)
    }));
};

Hut.prototype.getFrame = function (level) {
    level = level !== undefined ? level : this.getCurrentLevel();
    return this.isDestroyed() ? bundles.village.frames.breakdown : bundles[this.village.getBundleId()].frames[`${this.name}_${level}`];
};

Hut.prototype.getCurrentLevel = function () {
    let level = this.level - this.damage;

    if (level < 0) {
        level = 0;
    }

    if (level > Hut.MAX_LEVEL) {
        level = Hut.MAX_LEVEL;
    }

    return level;
};

Hut.prototype.getMaxLevel = function () {
    return this.maxLevel || this.upgrades.length;
};

Hut.prototype.upgrade = function (cb) {
    cb = cb || function () { };
    const eventName = cleverapps.EVENTS.SPENT.VILLAGE_HUT;
    const price = this.getPrice();
    const bought = cleverapps.user.spendHard(eventName, price.amount);

    if (bought) {
        this.setLevel(this.level + 1, true);

        this.village.upgradeHut(this, price, cb);

        return true;
    } 
    cb();
};

Hut.prototype.repair = function () {
    const eventName = cleverapps.EVENTS.SPENT.VILLAGE_HUT;
    const price = this.getPrice();
    const bought = cleverapps.user.spendHard(eventName, price.amount);

    if (bought) {
        this.setDamage(this.damage - 1);
    }
};

Hut.prototype.canBuild = function () {
    return this.village.isStateBuild() && !this.isComplete();
};

Hut.prototype.canAttack = function () {
    return this.getCurrentLevel() > 0;
};

Hut.prototype.setLevel = function (level, silent) {
    this.level = level;

    if (this.level > Hut.MAX_LEVEL) {
        this.level = Hut.MAX_LEVEL;
    }

    if (this.level < 0) {
        this.level = 0;
    }

    this.village.updateProgress();

    this.setUpgradeTool(false);

    if (!silent) {
        this.trigger("changeLevel");
    }

    this.checkUpgradeable();
};

Hut.prototype.setDamage = function (damage, silent) {
    this.damage = damage;

    if (this.damage > this.level) {
        this.damage = this.level;
    }

    if (this.damage < 0) {
        this.damage = 0;
    }

    this.village.save();

    if (!silent) {
        this.trigger("changeLevel");
    }
};

Hut.prototype.isComplete = function () {
    return this.level === this.upgrades.length && !this.damage;
};

Hut.prototype.isDestroyed = function () {
    return this.level === this.damage && this.damage !== 0;
};

Hut.prototype.getPrice = function () {
    const priceData = (this.damage ? this.repairs[this.getCurrentLevel()] : this.upgrades[this.level]) || { hard: 10000000 };
    const type = Object.keys(priceData)[0];
    const amount = priceData[type];
    return {
        type,
        amount
    };
};

Hut.prototype.getInfo = function () {
    const info = {
        level: this.level,
        name: this.name
    };

    if (this.damage) {
        info.damage = this.damage;
    }

    return info;
};

Hut.prototype.load = function (data) {
    if (!data) {
        return;
    }

    this.level = data.level || this.level;
    this.damage = data.damage || this.damage;

    this.setLevel(this.level);
};

Hut.prototype.onClick = function () {
    this.village.onHutClick(this);
};

Hut.prototype.onDoubleClick = function () {
    this.village.onHutDoubleClick(this);
};

Hut.prototype.setUpgradeTool = function (isOpen) {
    if (this.upgradeTool !== isOpen && this.level < Hut.MAX_LEVEL) {
        this.upgradeTool = isOpen;
        this.trigger("setUpgradeTool", isOpen);
    } else if (this.upgradeTool !== isOpen && !isOpen && this.level === Hut.MAX_LEVEL) {
        this.upgradeTool = isOpen;
        this.trigger("setUpgradeTool", isOpen);
    }
};

Hut.prototype.checkUpgradeable = function () {
    const price = this.getPrice();
    const upgradeable = this.isComplete() ? false : cleverapps.user.canTakeHard(price.amount);

    if (this.upgradeable !== upgradeable) {
        this.upgradeable = upgradeable;
        this.trigger("changeUpgradeable");
    }
};

Hut.prototype.attack = function (f) {
    this.trigger("attack", f);
};

Hut.MAX_LEVEL = 4;

Hut.UPGRADE_COST_COEFFS_FOUR = [
    [1.5, 1.8, 3.0, 5.0],
    [2.0, 2.5, 4.2, 6.9],
    [2.5, 3.0, 5.2, 8.5],
    [3.0, 3.6, 6.2, 10.2],
    [4.0, 5.0, 8.3, 13.6]
];

Hut.UPGRADE_COST_COEFFS_FIVE = [
    [1.3, 1.5, 1.8, 3.1, 3.9],
    [1.7, 2.0, 2.5, 4.3, 5.4],
    [2.1, 2.5, 3.0, 5.3, 6.6],
    [2.3, 2.8, 3.3, 5.9, 7.2],
    [3.4, 4.1, 4.9, 8.5, 10.6]
];
